import { render, staticRenderFns } from "./supervision.vue?vue&type=template&id=2c860f0b&scoped=true&"
import script from "./supervision.vue?vue&type=script&lang=js&"
export * from "./supervision.vue?vue&type=script&lang=js&"
import style0 from "./supervision.vue?vue&type=style&index=0&id=2c860f0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c860f0b",
  null
  
)

export default component.exports